import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Page Components
import Home from './pages/Home';
import Mission from './pages/Mission';
import Impact from './pages/Impact';
import Team from './pages/Team';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import Memo from './pages/Memo';
import ProtectedRoute from './components/ProtectedRoute';

// Auth Context Provider
import { AuthProvider } from './contexts/AuthContext';

// Placeholder for additional pages
const Careers = () => (
  <main>
    <section className="section" style={{paddingTop: '10rem', backgroundColor: 'white', minHeight: '80vh'}}>
      <div className="container" style={{maxWidth: '1000px', margin: '0 auto', padding: '0 2rem'}}>
        <div className="section-title" style={{textAlign: 'center', marginBottom: '3rem'}}>
          <h1 style={{fontSize: '3rem', fontWeight: 700, color: '#AA5B52', marginBottom: '1.5rem'}}>Get Involved</h1>
          <p style={{fontSize: '1.3rem', color: '#666', lineHeight: 1.6, maxWidth: '700px', margin: '0 auto'}}>
            Join us in democratizing healthcare access and building medical justice. Every voice matters in creating systemic change.
          </p>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '3rem'}}>
          <div style={{background: '#f7e6e1', borderRadius: '1.5rem', padding: '2rem', textAlign: 'center'}}>
            <h3 style={{color: '#AA5B52', marginBottom: '1rem', fontSize: '1.4rem'}}>Healthcare Professionals</h3>
            <p style={{color: '#444', lineHeight: 1.6}}>
              Help us build better diagnostic tools and safety systems. Your clinical expertise is essential for creating meaningful change.
            </p>
          </div>
          
          <div style={{background: '#e8f4f8', borderRadius: '1.5rem', padding: '2rem', textAlign: 'center'}}>
            <h3 style={{color: '#2D5B7B', marginBottom: '1rem', fontSize: '1.4rem'}}>Technologists</h3>
            <p style={{color: '#444', lineHeight: 1.6}}>
              Apply your skills in AI, data science, and software engineering to solve critical healthcare challenges.
            </p>
          </div>
          
          <div style={{background: '#fff8e1', borderRadius: '1.5rem', padding: '2rem', textAlign: 'center'}}>
            <h3 style={{color: '#f57c00', marginBottom: '1rem', fontSize: '1.4rem'}}>Advocates & Researchers</h3>
            <p style={{color: '#444', lineHeight: 1.6}}>
              Join our mission to create policy change, conduct research, and advocate for patient rights and healthcare justice.
            </p>
          </div>
        </div>
        
        <div style={{textAlign: 'center', marginTop: '3rem'}}>
          <p style={{fontSize: '1.1rem', color: '#666', marginBottom: '2rem'}}>
            Ready to make a difference? Contact us to learn about current opportunities.
          </p>
          <a href="mailto:hello@afterimage.health" style={{
            display: 'inline-block',
            background: '#AA5B52',
            color: 'white',
            padding: '1rem 2rem',
            borderRadius: '2rem',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '1.1rem'
          }}>Contact Us</a>
        </div>
      </div>
    </section>
  </main>
);

const ForPatients = () => (
  <main>
    <section className="section" style={{paddingTop: '10rem', backgroundColor: 'white'}}>
      <div className="container">
        <div className="section-title">
          <h1>For Patients</h1>
          <p>Resources and information for patients interested in our services.</p>
        </div>
      </div>
    </section>
  </main>
);

const ForProviders = () => (
  <main>
    <section className="section" style={{paddingTop: '10rem', backgroundColor: 'white'}}>
      <div className="container">
        <div className="section-title">
          <h1>For Healthcare Providers</h1>
          <p>Information about how our platform can help improve your diagnostic accuracy.</p>
        </div>
      </div>
    </section>
  </main>
);

const Research = () => (
  <main>
    <section className="section" style={{paddingTop: '10rem', backgroundColor: 'white'}}>
      <div className="container">
        <div className="section-title">
          <h1>Research</h1>
          <p>Learn about the latest research on diagnostic errors and our approach to solving them.</p>
        </div>
      </div>
    </section>
  </main>
);

const Blog = () => (
  <main>
    <section className="section" style={{paddingTop: '10rem', backgroundColor: 'white'}}>
      <div className="container">
        <div className="section-title">
          <h1>Blog</h1>
          <p>News, updates, and insights from the Afterimage team.</p>
        </div>
      </div>
    </section>
  </main>
);

const Support = () => (
  <main>
    <section className="section" style={{paddingTop: '10rem', backgroundColor: 'white'}}>
      <div className="container">
        <div className="section-title">
          <h1>Support</h1>
          <p>Frequently asked questions and resources to help you get the most out of Afterimage.</p>
        </div>
      </div>
    </section>
  </main>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Home route is completely blank */}
            <Route path="/" element={<Home />} />
            
            {/* Login and Memo routes have no header or footer */}
            <Route path="/login" element={<Login />} />
            <Route path="/memo" element={
              <ProtectedRoute>
                <Memo />
              </ProtectedRoute>
            } />
            <Route path="/memo/update" element={
              <ProtectedRoute>
                <Memo />
              </ProtectedRoute>
            } />
            
            {/* All other routes have the standard layout with header and footer */}
            <Route path="/*" element={
              <>
                <Header />
                <Routes>
                  <Route path="/mission" element={<Mission />} />
                  <Route path="/impact" element={<Impact />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/careers" element={<Careers />} />
                  <Route path="/for-patients" element={<ForPatients />} />
                  <Route path="/for-providers" element={<ForProviders />} />
                  <Route path="/research" element={<Research />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
